import { gql } from '@apollo/client';

const DELETE_COMPLETION_CODE = gql`
    mutation deleteCompletionCode($iltID: UUID!, $completionCodeID: UUID!) {
        deleteCompletionCode(iltID: $iltID, completionCodeID: $completionCodeID) { 
            success
            message
        }
    }
`;

export default DELETE_COMPLETION_CODE;
